/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Subtitle_Export_File_Extension_LabelInputs */



/**
* | output |
* | --- |
* | "File Extension" |
*
* @param {Subtitle_Export_File_Extension_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const subtitle_export_file_extension_label = /** @type {((inputs?: Subtitle_Export_File_Extension_LabelInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Subtitle_Export_File_Extension_LabelInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Extension de fichier")
	if (locale === "de") return /** @type {LocalizedString} */ ("Dateierweiterung")
	if (locale === "it") return /** @type {LocalizedString} */ ("Estensione del file")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Расширение файла")
	if (locale === "es") return /** @type {LocalizedString} */ ("Extensión de archivo")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("文件扩展名")
	if (locale === "ja") return /** @type {LocalizedString} */ ("ファイル拡張子")
	if (locale === "hi") return /** @type {LocalizedString} */ ("फाइल एक्सटेंशन")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Extensão de arquivo")
	return /** @type {LocalizedString} */ ("File Extension")
});